import * as React from 'react';
import Paper from '@mui/material/Paper';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/Paper": Paper, "@mui/material/MenuList": MenuList, "@mui/material/MenuItem": MenuItem, "@mui/material/ListItemText": ListItemText, "@mui/material/ListItemIcon": ListItemIcon, "@mui/icons-material/RadioButtonChecked": RadioButtonChecked, "@mui/icons-material/RadioButtonUnchecked": RadioButtonUnchecked } } });
export default ClientProvider;
